var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06153 12.348C1.97819 12.1235 1.97819 11.8765 2.06153 11.652C2.87323 9.68385 4.25104 8.00103 6.0203 6.81689C7.78955 5.63275 9.87057 5.00061 11.9995 5.00061C14.1285 5.00061 16.2095 5.63275 17.9788 6.81689C19.748 8.00103 21.1258 9.68385 21.9375 11.652C22.0209 11.8765 22.0209 12.1235 21.9375 12.348C21.1258 14.3161 19.748 15.999 17.9788 17.1831C16.2095 18.3672 14.1285 18.9994 11.9995 18.9994C9.87057 18.9994 7.78955 18.3672 6.0203 17.1831C4.25104 15.999 2.87323 14.3161 2.06153 12.348Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeView);
export default __webpack_public_path__ + "static/media/codeView.fc5186cf74e70b16d269552c96ad31e2.svg";
export { ForwardRef as ReactComponent };